import React from 'react';
import { useRouter } from 'next/router';
import { Users, CheckCircle } from 'lucide-react';

const TeamAdminBanner = () => {
  const router = useRouter();

  return (
    <div className="mb-10 bg-white/80 backdrop-blur-sm border border-gray-100 rounded-2xl p-6 shadow-sm relative overflow-hidden">
      {/* Subtle accent bar */}
      <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-[#2CA6A4]" />

      <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-8 pl-4">
        <div className="flex-grow">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-8 h-8 bg-teal-50 rounded-lg flex items-center justify-center">
              <Users className="w-4 h-4 text-[#2CA6A4]" />
            </div>
            <h2 className="text-xl font-bold text-gray-900">Team Admin</h2>
          </div>
          <p className="text-gray-600 font-medium mb-4">
            Your account has special privileges to manage team members,
            schedulers, and metrics.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="flex items-center gap-2 text-sm text-gray-500">
              <CheckCircle className="w-4 h-4 text-teal-400" />
              <span>Manage Users & Roles</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-500">
              <CheckCircle className="w-4 h-4 text-teal-400" />
              <span>Team-wide Schedulers</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-500">
              <CheckCircle className="w-4 h-4 text-teal-400" />
              <span>Advanced Reporting</span>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap gap-3 lg:self-center">
          <button
            onClick={() => router.push('/team/users')}
            className="px-6 py-2.5 bg-[#2CA6A4] text-white text-sm font-bold rounded-xl hover:bg-[#238a88] transition-all shadow-sm flex items-center gap-2"
          >
            Manage Users
          </button>
          <button
            onClick={() => router.push('/team/schedulers')}
            className="px-6 py-2.5 bg-white text-gray-700 border border-gray-200 text-sm font-bold rounded-xl hover:bg-gray-50 transition-all shadow-sm"
          >
            Team Schedulers
          </button>
          <button
            onClick={() => router.push('/metrics')}
            className="px-6 py-2.5 bg-white text-gray-700 border border-gray-200 text-sm font-bold rounded-xl hover:bg-gray-50 transition-all shadow-sm"
          >
            Reports
          </button>
        </div>
      </div>
    </div>
  );
};

export default TeamAdminBanner;
